import { enumElementBorderStyle } from "../constants";
import { QFloatingBubbleButton } from "../CoreApp/QFloatingBubbleButton";

export function AddBubbleButton(parent, x, y, label, color, cmdCode, radius) {
  var bubbleButton = new QFloatingBubbleButton();
  bubbleButton.InitButton(30, 27, x, y, label, color, cmdCode);
  bubbleButton.fBorderRadius = radius;
  bubbleButton.SetBorderThickness(2);
  bubbleButton.SetBorderStyle(enumElementBorderStyle.roundBorder);
  bubbleButton.SetBorderColor(parent.GetFillColor());
  bubbleButton.SetMarginH(25);
  bubbleButton.AutoSize();
  parent.PushElement(bubbleButton);
  return bubbleButton;
}
